import React from "react";
import HomeView from "components/Home/HomeView";

const HomeContainer = (props) => {
  const { data } = props;
  return <HomeView data={data} />;
};

export default HomeContainer;
